<div class="card">
  <app-menu></app-menu>
  @if ((getTables$ | async) !== null) {
    @if (hasError()) {
  <app-error [error]="error()"></app-error>
  } @else {

  <div class="app-container p-28 pt-0 pb-10">
    <router-outlet></router-outlet>
  </div>
  } }
</div>
